import React, { Component } from "react";
import ContentLoader from "react-content-loader";
import "./shimmer.scss";

const VideoLoader = () => {
  return (
    <div className="col-lg-4 col-md-6 col-sm-12 community-video-wrapper">
      <div
        className="community-video-card"
        style={{
          position: "relative",
          padding: 0,
          margin: 0,
          overflow: "hidden",
        }}
      >
        <ContentLoader
          width={500}
          height={325}
          speed={1.2}
          viewBox="0 0 500 325"
          backgroundColor="#e8e0f8"
          foregroundColor="#c9b8f0"
        >
          <rect x="0" y="0" rx="0" ry="0" width="500" height="165" />
          <rect x="10" y="175" rx="4" ry="4" width="75%" height="20" />
          <rect x="10" y="205" rx="4" ry="4" width="40%" height="16" />
          <rect x="10" y="231" rx="4" ry="4" width="55%" height="14" />
          <rect x="10" y="280" rx="4" ry="4" width="30%" height="14" />
        </ContentLoader>
      </div>
    </div>
  );
};

class VideoShimmer extends Component {
  render() {
    return (
      <>
        <VideoLoader />
        <VideoLoader />
        <VideoLoader />
        <VideoLoader />
        <VideoLoader />
        <VideoLoader />
      </>
    );
  }
}

export default VideoShimmer;
